<div class="min-h-[180px] bg-white top-0 z-10 " [class.sticky] = "sticky" [ngClass]="sticky && links.length > 0 ? 'top-[-100px] fixed' : '' || title ? '' : 'min-h-[70px]'">
   <div class="pl-[55px] pt-[32px]" [ngClass]="title ? '' : 'pt-[5px]'">


      <div class="inline-flex w-full justify-between relative" [ngClass]="links.length > 0 || breadcrumbs.length > 0 ? 'top-4' : 'top-10'">

         <div>
            <div *ngIf="pVenditaName || pv_name">{{(pVenditaName || pv_name) | uppercase}}</div>
            <div class="mt-5" style="font-size: 54px; font-weight: 300">{{title}}</div>
         </div>
         <div class="pr-20" *ngIf="showExit">
            <a class="no-underline text-ibm-primary cursor-pointer mr-52" (click)="onclickExit()">Esci</a>
         </div>

      </div>

      <div class="mt-16" *ngIf="subtitle">
         <h3 class="text-2xl ">{{subtitle}}</h3>
      </div>

      <nav class="bg-white" *ngIf="links && links.length > 0">

         <div class="max-w-7xl relative">

            <div class="relative flex h-16 justify-between">
               <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">

                  <!-- Mobile menu button -->
                  <button type="button" class="inline-flex items-center justify-center rounded-md p-2 text-gray-400
                                            hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2
                                            focus:ring-inset focus:ring-ibm-primary"
                          aria-controls="mobile-menu" aria-expanded="false" (click)="clickExpandMobileMenu()">
                     <span class="sr-only">Open main menu</span>

                     <svg class="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                     </svg>

                     <svg class="hidden h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                     </svg>
                  </button>
                  <div class="pr-20" >
                     <a class="no-underline text-ibm-primary cursor-pointer" (click)="onclickExit()">Esci</a>
                  </div>

               </div>

               <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start mt-5">
                  <div class="hidden sm:flex">
                     <div *ngFor="let link of links">
                        <a *ngIf="link.link && (link.show == true || link.show == undefined)"
                           [routerLink]="[link.link]"
                           class="px-5 pb-3 pt-6 decoration-transparent desktop"
                           routerLinkActive="border-ibm-primary text-gray-900 font-bold">
                           {{link.text}} <span *ngIf="link.has_badge"><span class="absolute top-[26px] ml-2 h-[15px] w-[15px] bg-red-600 rounded-2xl inline-block animate-bounce"></span></span>
                        </a>
                        <!--                           -->
                        <!--                           (click)="link.active = true"-->
                        <a *ngIf="!link.link && (link.show == true || link.show == undefined)"
                           href="javascript:void(0)"
                           (click)="clickTab(link)"
                           class="px-5 pb-3 pt-6 decoration-transparent desktop"
                           [ngClass]="link.active ? 'border-ibm-primary text-gray-900 font-bold' : ''">
                           {{link.text}} <span *ngIf="link.has_badge"><span class="absolute top-[23px] ml-2 h-[15px] w-[15px] bg-red-600 rounded-2xl inline-block animate-pulse"></span></span>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <!-- Mobile menu, show/hide based on menu state. -->
         <div class="sm:hidden transition duration-150 ease-in-out" id="mobile-menu"
              [hidden]="!show">
            <div class="space-y-1 pt-2 pb-4">
               <a *ngFor="let link of links" [routerLink]="[]" (click)="clickTab(link)"
                  class="mobile"
                  routerLinkActive="">{{link.text}} {{link.show}}</a>
            </div>
         </div>
      </nav>

      <nav class="bg-white pt-3 flex justify-between top-8 relative" *ngIf="breadcrumbs && breadcrumbs.length > 0">
         <div class="inline-block ">
            <a *ngFor="let item of breadcrumbs; let i = index" class="inline no-underline cursor-pointer" (click)="clickBreadcrumb(item, i)" [ngClass]="item.active ? 'text-black' : 'text-ibm-primary'">
               {{item.text}} <span class="text-primary">/</span>
            </a>
         </div>

         <div class="pr-20" *ngIf="showClickSave">
            <a class="ds-btn ds-btn-info-outline ds-btn-sm" type="button" (click)="clickSaveExit()">Salva ed esci</a>
         </div>
      </nav>


   </div>
</div>
<!--</div>-->

<div *ngFor="let w of dataSrv.warnings">
   <app-notifications *ngIf="w.always_show"
                      [severity]="w.severity"
                      [message]="w.message"
                      [subMessage]="w.sub_message"
                      [showCompletaRegistrazione]="dataSrv.plan_is_demo"
                      [showAggiornaPiano]="dataSrv.pianoAttivoEsercizio?.data?.is_free!"
                      [vendorSlug]="vendorSlug"
   ></app-notifications>
</div>
